import type { TrackPageVisitOutput } from '@mbbe/types';
import { apiFetch } from './apiClient';
import {
  ANALYTICS_CONSENT_GRANTED,
  ANALYTICS_CONSENT_FIELD,
  hasAnalyticsConsent,
} from './analyticsConsent';
import { redactPrivatePath } from './privatePaths';

/**
 * Sends one first-party page-visit event, but only while the visitor's current choice is
 * `accepted` (#125). The check is repeated here, at send time, so a withdrawal between
 * scheduling and sending still sends nothing. Returns whether a request was attempted.
 */
export async function trackPageVisit(page: string, projectId?: number): Promise<boolean> {
  if (!hasAnalyticsConsent()) return false;
  const trackedPage = redactPrivatePath(page);
  try {
    await apiFetch<TrackPageVisitOutput>('/track', {
      method: 'POST',
      body: JSON.stringify({ page: trackedPage, projectId, [ANALYTICS_CONSENT_FIELD]: ANALYTICS_CONSENT_GRANTED }),
    });
  } catch (error) {
    console.error('Failed to track page visit:', error);
  }
  return true;
}
